<template>

  <div class="widget-content-promotion" :class="{ 'image-only': isImageOnly }" v-if="promotion">
    <br>

    <div class="promotion-image" v-if="settings.showImage && imageAsset && !isVideo" :style="imageStyle"></div>
    <video v-else-if="settings.showImage && imageAsset && isVideo"
           class="promotion-image promotion-video"
           :autoplay="!freeze"
           loop
           muted
           playsinline
           preload="metadata"
           :poster="imageAsset.thumbUrl"
           :style="videoStyle">
      <source :src="imageAsset.url">
    </video>

    <div class="title" v-if="settings.showTitle || settings.showSubtitle">
      <div class="title-inner">
        <dmb-widget-styled-text v-if="settings.showTitle" :style="settings.titleTextStyle">{{
            promotion.title
          }}
        </dmb-widget-styled-text>
        <div class="allergy-icons">
          <dmb-asset v-if="promotion.glutenfree" :asset-id="showStyle.glutenfreeAssetId" stuffed></dmb-asset>
          <dmb-asset v-if="promotion.veggie" :asset-id="showStyle.veggieAssetId" stuffed></dmb-asset>
        </div>
      </div>

      <dmb-widget-styled-text v-if="settings.showSubtitle && promotion.subtitle"
                              :style="settings.subtitleTextStyle">{{ promotion.subtitle }}
      </dmb-widget-styled-text>
    </div>

    <div class="price" v-if="settings.showPriceRegular || settings.showPricePromo">

      <dmb-widget-styled-text v-if="settings.showPriceRegular" :style="settings.priceTextStyle">
        <dmb-price :currency="widget.settings.showCurrency" :mode="settings.priceMode"
                   :price="promotion.priceRegular"/>
      </dmb-widget-styled-text>

      <dmb-widget-styled-text v-if="settings.showPricePromo" :style="settings.pricePromoTextStyle">
        <dmb-price :currency="widget.settings.showCurrency" :mode="settings.priceMode"
                   :price="promotion.pricePromo"/>
      </dmb-widget-styled-text>
    </div>

  </div>
  <div v-else-if="freeze" class="widget-content-placeholder">{{
      $t('app.widgets.widgetContentPromotion.noPromotion')
    }}
  </div>

</template>

<script>

import {Vue, Options} from 'vue-class-component'

import WidgetStyledText from '../WidgetStyledText.vue';
import Price from '../Price.vue';

import PromotionState from '../../enum/PromotionState';
import WidgetSettingsPromotionMode from '../../enum/WidgetSettingsPromotionMode';
import AssetType from '../../enum/AssetType';
import Asset from "../ui/Asset.vue";

export default Options({
  name: 'dmb-widget-content-promotion',
  components: {
    [WidgetStyledText.name]: WidgetStyledText,
    [Asset.name]: Asset,
    [Price.name]: Price,
  },
  props: {
    widget: Object,
    freeze: Boolean
  }
})(
    class WidgetContentPromotion extends Vue {

      get settings() {

        return this.widget.settings;
      }

      get promotion() {

        const mode = this.widget.settings.mode;
        let promo = null;

        if (mode === WidgetSettingsPromotionMode.RANDOM) {

          promo = this.$store.state.promotions.randomPromotion;
        } else if (mode === WidgetSettingsPromotionMode.SPECIFIC && this.widget.settings.promotionId) {

          promo = this.$store.getters.getPromotion(this.widget.settings.promotionId);
        }

        if (!promo) {
          return null;
        }

        if (!this.freeze && promo.state !== PromotionState.AVAILABLE) {
          return null;
        }

        return promo;
      }

      get showStyle() {

        return this.$store.state.style.showStyle;
      }

      get imageAsset() {

        return this.promotion.imageAssetId ? this.$store.getters.getAsset(this.promotion.imageAssetId) : null;
      }

      get isVideo() {

        return this.imageAsset?.type === AssetType.VIDEO;
      }

      get imageStyle() {
        if (!this.imageAsset) {
          return {};
        }

        const url = this.isVideo && this.imageAsset.thumbUrl ? this.imageAsset.thumbUrl : this.imageAsset.url;

        const style = {
          backgroundImage: `url(${url})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center center'
        };

        if (this.settings.contentMode === 'CONTAIN') {
          style.backgroundSize = 'contain';
        } else {
          style.backgroundSize = 'cover';
        }

        return style;
      }

      get videoStyle() {

        return {
          objectFit: this.settings.contentMode === 'CONTAIN' ? 'contain' : 'cover',
          objectPosition: 'center center'
        };
      }

      get isImageOnly() {
        const st = this.settings;

        return st.showImage && !st.showTitle && !st.showSubtitle && !st.showPricePromo && !st.showPriceRegular;
      }
    }
)

</script>
<style src="../../../scss/component/widget/WidgetContentPromotion.scss" lang="scss"></style>
